import { render, staticRenderFns } from "./ModalPassword.vue?vue&type=template&id=6884d206&"
import script from "./ModalPassword.vue?vue&type=script&lang=js&"
export * from "./ModalPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalPassword.vue?vue&type=style&index=0&id=6884d206&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports